const logger = (message: string, tag: string, ...rest: any) => {
  const string = `%c${tag || 'Logger'}%c ${message}`;

  if (localStorage.getItem('log')) {
    console.log(
      string,
      'color: black; background-color: yellow; padding: 2px 5px; border-radius: 2px; margin: 0;',
      {
        message,
      },
      ...rest,
    );
  }
};

export default logger;
